/* eslint-disable react/require-default-props,react/destructuring-assignment */

import React from 'react';
import PropTypes from 'prop-types';
import reactCSS from 'reactcss';
import { PortalButton } from '../../PortalButton/PortalButton';
import './SubscriptionPlanTile.scss';

// eslint-disable-next-line react/prefer-stateless-function
export class SubscriptionPlanTile extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
    price: PropTypes.string,
    priceNote: PropTypes.string,
    originalPrice: PropTypes.string,
    feature: PropTypes.string,
    action: PropTypes.func,
    actionLabel: PropTypes.string,
    brandColor: PropTypes.string,
    headerColor: PropTypes.string,
  };

  render() {
    const {
      name,
      desc,
      price,
      priceNote,
      originalPrice,
      feature,
      actionLabel,
      brandColor,
      headerColor,
    } = this.props;

    const styles = reactCSS({
      default: {
        header: {
          backgroundColor: `${headerColor || brandColor}`,
        },
        brandColor: {
          color: `${brandColor}`,
        },
      },
    });

    return (
      <subscription-plan>
        <header className="tile-header" style={styles.header}>
          {name}
        </header>
        <div className="tile-body">
          <div className="tile-price">
            <span>
              {price && <p style={styles.brandColor}>{price}</p>}
              {originalPrice && (
                <div className="original-price strikethrough">
                  {originalPrice}
                </div>
              )}
              {priceNote && <small>{priceNote}</small>}
            </span>
          </div>
          <p className="tile-desc">{desc}</p>
          {feature && (
            <p className="tile-feature" style={styles.brandColor}>
              {feature}
            </p>
          )}
          <div className="tile-actions">
            {name === 'School Pricing Packages' ? (
              <p className="contact-info" style={styles.brandColor}>
                Contact:
                <br />
                contact@teach.com.au
              </p>
            ) : (
              <PortalButton onClick={this.props.action}>
                <span>{actionLabel}</span>
              </PortalButton>
            )}
          </div>
        </div>
      </subscription-plan>
    );
  }
}
